module.exports = __webpack_public_path__ + "img/rentedicon.2845f5d2.svg";